import '../vendor';

import '../general/ofi';
import '../general/anchor';
import '../general/menu.js';
import '../general/find';
import '../general/modal-social';

import './lecture/exponats';


// WEBPACK FOOTER //
// ./src/js/pages/lecture-cycle.js